<template>
  <div class="dashboard_right absolute">
    <!-- 整站面板 -->
    <!-- <div class="dashboard-panel">
      <div class="electric">
        <label>{{ electricName }}</label>
        <div class="cont">
          <span class="value">{{ electric }}</span>
          <span class="unit">{{['A','A','KW'][($route.query.index-1)||0]}}</span>
        </div>
      </div>
      <div class="pressure">
        <label>{{pressureName}}</label>
        <div class="cont">
          <span class="value">{{ pressure }}</span>
          <span class="unit">{{['kPaG','mbarA','mbarG'][($route.query.index-1)||0]}}</span>

        </div>
      </div>
    </div> -->
    
    <div class="dashboard-panel" >
        <div class="electric" :style="`${topIndex.length>1?'border-right: 1px solid #fff;':''}`">
          <label>{{ topIndex.length?measurements_list[topIndex[0]]&&measurements_list[topIndex[0]].name:'-' }}</label>
          <div class="cont">
            <span class="value">{{ topIndex.length&&equip_data.is_iot_ready?measurements_list[topIndex[0]]&&measurements_list[topIndex[0]].v:'-' }}</span>
            <span class="unit">{{topIndex.length&&equip_data.is_iot_ready?measurements_list[topIndex[0]]&&measurements_list[topIndex[0]].unit:''}}</span>
          </div>
        </div>
        <div class="pressure" >
          <label>{{topIndex.length?measurements_list[topIndex[1]]&&measurements_list[topIndex[1]].name:'-'}}</label>
          <div class="cont">
            <span class="value">{{ topIndex.length&&equip_data.is_iot_ready?measurements_list[topIndex[1]]&&measurements_list[topIndex[1]].v:'-' }}</span>
            <span class="unit">{{topIndex.length&&equip_data.is_iot_ready?measurements_list[topIndex[1]]&&measurements_list[topIndex[1]].unit:''}}</span>
          </div>
        </div>
      </div>
      
    <div class="right_contain">
      <div class="children" style="height:42%">
        <Status :equip_data="equip_data" :measurements_list="measurements_list"></Status>
      </div>
      <div class="children" style="height:58%">
        <Top :name="$t('Recent Events')" :show-button="false"></Top>
        <div class="top_data" style="height: calc(100% - 30px); ">
          <EquipWarning v-if="equip_data.id" :equip_data="equip_data"></EquipWarning>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Status from "./component/Status.vue";
import EquipWarning from "./component/EquipWarning.vue";
import moment from "moment";
export default {
  props: ["equip_data","topIndex","measurements_list"],
  data() {
    return {
      electricName:'机组运行电流',
      pressureName:'机组吸气压力',
      electric: 35.01,
      pressure: -94,
      currentChecked: "data",
      roots_pump_ma212_id: `roots_pump_ma212_${+new Date()}`,
      roots_pump_ms212_id: `roots_pump_ms212_${+new Date()}`,
      timer: null,
      timer1: null,
      timer2: null
    };
  },
  computed: {},
  watch: {
    
  },
  unmounted() {
  clearInterval(this.timer)
  },
  mounted() {
    this.timer = setInterval(() => {
      if(this.$route.query.index==1){
        this.pressure = this.randoms(-94, -98);
        this.electric = this.randoms(35.01, 36.5);
        this.electricName = '机组运行电流'
        this.pressureName = '机组吸气压力'
      }else if(this.$route.query.index==2){
        this.pressure = this.randoms(9, 10);
        this.electric = this.randoms(35.01, 36.5);
        this.electricName = '机组运行电流'
        this.pressureName = '机组吸气压力'
      }else{
        this.pressure = this.randoms(700, 950);
        this.electric = this.randoms(170, 202);
        this.electricName = '功率'
        this.pressureName = '出口压力'
      }

    }, 1000);
  },
  methods: {
    moment,
    randoms(min, max) {
      return parseFloat(Math.random() * (max - min) + min).toFixed(1);
    },
  },
  components: {
    Status,
    EquipWarning
  }
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");

.dashboard_right {
  width: 400px;
  height: 100%;
  top: 0;
  right: 0;
  display: flex;
  flex-flow: column;
  .right_contain {
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow: hidden;
    .children {
      width: 100%;
      overflow: auto;
      height: auto;
      padding: 20px 20px 10px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    
      &:nth-of-type(2) {
        margin-bottom: 0px;
      }
    }
  }

  .dashboard-panel {
    min-height: 92px;
    display: flex;
    padding: 5px 0;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    margin-bottom: 10px;
    .electric,
    .pressure {
      flex: 1;
      padding: 10px 10px;
      box-sizing: border-box;
      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        color: #00e7ff;
      }
      label {
        font-size: 16px;
      }
      .value,
      .unit {
        font-size: 20px;
      }
    }
    .electric {
      // border-right: 1px solid #fff;
      font-size: 16px;
    }
  }
}
.shockData {
  height: 100%;
  display: flex;
  flex-flow: column;
  .chart-list {
    margin-top: 15px;
    flex: 1;
    display: flex;
    flex-flow: column;
    .chart {
      flex: 1;
      &:nth-last-of-type(1) {
        border-bottom: 0;
        margin-bottom: 0;
      }
    }
  }
}
</style>
